import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { onPageEditing } from 'utils';

import ProjectMarkers from 'components/ProjectMarkers';
import SliderListBlock from 'components/SliderListBlock';
import ProjectCard from 'components/ProjectCard';
import Map from 'components/Map';
import Button from 'components/Button';

import css from './MapLocationBlock.module.scss';

let L = typeof window !== 'undefined' ? require('leaflet') : { latLng: ()=>{}};

class ProjectsBlock extends React.Component {
    static propTypes = {
        projects: PropTypes.array,
        active: PropTypes.number,
        callback: PropTypes.func
    };

    activeChanged (){
        return (item) => {
            // trigger callback
            this && this.props && this.props.callback && this.props.callback.apply(null, [item]);
        };
    }

    render(){
        const { projects } = this.props;
        return (
            <SliderListBlock data={projects} callback={this.activeChanged()} Component={ProjectCard} mode={'horizontal-list'} />
        );
    }
}

class MapLocationBlock extends React.Component {
    static propTypes = {
        "header": PropTypes.string,
        "projectsLinkHeading": PropTypes.string,
        "projectsLink": PropTypes.string,
        "projects": PropTypes.arrayOf(PropTypes.shape({
            "id":  PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            "name": PropTypes.string.isRequired,
            "location": PropTypes.string.isRequired,
            "image": PropTypes.string.isRequired,
            "zoomLevel": PropTypes.number.isRequired,
            "division": PropTypes.string,
            "text": PropTypes.string
        })),
        "tileLayer": PropTypes.string
    }

    componentDidMount(){
        setTimeout(() => {
            if(this.props.projects.length > 0) {
                this.flyTo();
            }
        }, 1);
    }

    flyTo = (target) => {
        const map = this.map.leaflet.leafletElement;
        if(!target){
            target = map.getSize().divideBy(2);
        }
        var targetPoint = target.subtract([this.projects.clientWidth, 0]),
            targetLatLng = map.containerPointToLatLng(targetPoint);

        map.flyTo(targetLatLng);
    }

    projectChanged(){
        return (item) => {
            const map = this.map.leaflet.leafletElement;
            let latlng = item.location.trim().split(",");
            let zoom = parseInt(item.zoomLevel, 10);
            if(latlng.length == 2){
                let targetLatLng = L.latLng(parseFloat(latlng[0]), parseFloat(latlng[1]));

                // Add offset

                // mobile
                let sub = [0, -map._container.clientHeight / 5];
                // desktop
                if(typeof window !== "undefined" && window.matchMedia("(min-width: 960px)").matches){
                    sub = [map._container.clientWidth / 5, 0];
                }

                let targetPoint = map.project(targetLatLng, zoom).subtract(sub);
                targetLatLng = map.unproject(targetPoint, zoom);

                map.flyTo(targetLatLng, zoom);
            }else{
                console.error("Couldn't parse coordinates", item.location);
            }
        };
    }

    render() {
        const {
            header,
            projectsLinkHeading,
            projectsLink,
            projects,
            tileLayer
        } = this.props;

        const initialProject = projects.length && projects[0];
        const initialLocation = initialProject ? initialProject.location.split(',').map(parseFloat) : [64.2869407, 8.784715];
        const initialZoom = initialProject ? parseInt(initialProject.zoomLevel, 10) : 10;

        return (
            <div className={css.block}>
                <div className={css.map} id="project-list">
                    <Map
                        ref={node=> this.map=node}
                        center={initialLocation}
                        zoomLevel={initialZoom}
                        useZoom={false}
                        useScroll={false}
                        style={{
                            position: 'absolute'
                        }}
                        options={{
                            dragging: false,
                            touchZoom: false,
                            doubleClickZoom: false,
                            scrollWheelZoom: false,
                            boxZoom: false,
                            keyboard: false,
                            tap: false
                        }}
                        tileLayer={tileLayer}
                    >
                        <ProjectMarkers
                            projects={projects}
                            projectStatusLabel={"TOOD status label"}
                            //onMarkerClick={(e,b) => { console.log(e,b)}}
                            filterSearch={() => true}
                            options={
                                {
                                    disableClusteringAtZoom: 10
                                }
                            }
                        />
                    </Map>
                    <div className={css["call-to-action"]}>
                        <Button tertiary href={projectsLink}>{projectsLinkHeading}</Button>
                    </div>
                </div>
                <div ref={node => this.projects = node} className={css.projects}>
                    {header && (
                        <h1 className={cn("block-title-large", css.heading)} {...onPageEditing("Heading")}>
                            {header}
                        </h1>
                    )}
                    <div className={cn("project-list", css["project-list"])}>
                        {projects && projects.length > 0 &&
                            <ProjectsBlock
                                projects={projects}
                                callback={this.projectChanged()}
                            />
                        }
                        <div className={css["call-to-action"]}>
                            <Button tertiary href={projectsLink}>{projectsLinkHeading}</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MapLocationBlock;



// WEBPACK FOOTER //
// ./src/components/MapLocationBlock/MapLocationBlock.jsx